package com.narbase.letsgo.web.views.voiceassistant

import com.narbase.letsgo.dto.KmmLong
import kotlin.time.Duration.Companion.milliseconds

fun KmmLong.asReadableDuration(): String {
    val millis = this.toLong()
    if (millis <= 0L) return "-"
    return millis.milliseconds.toString()
}
